import { SpinnerService } from "./../services/spinner.service";
import { SpinnerComponent } from "./../spinner/spinner.component";
import { VisitService } from "./../services/visit.service";
import { MessageService } from "../services/message.service";
import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { EngineService } from "../services/engine.service";
import { Engine } from "../models/engine";
import { Message } from "../common/message";
import { forkJoin } from "rxjs";

let ELEMENT_DATA = [];

@Component({
  selector: "app-engine-report",
  templateUrl: "./engine-report.component.html",
  styleUrls: ["./engine-report.component.scss"],
})
export class EngineReportComponent implements OnInit {
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = [
    "SN",
    "powertrainId",
    "name",
    "code",
    "alias",
    "startDate",
    "status",
    "lastHourRead",
    "lastMaintenance",
  ];
  dataSource = new MatTableDataSource();
  cssStyle: string =
    "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700);@import url(https://fonts.googleapis.com/icon?family=Material+Icons);@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.8.2/css/all.min.css);@import url(https://fonts.googleapis.com/css?family=Cairo:400,600,700&display=swa);@import url(~@angular/material/prebuilt-themes/indigo-pink.css);body,html{height:100%;margin:0 auto;direction:rtl;font-family:Cairo,sans-serif}a{text-decoration:none}.container{width:95%;margin:0 auto;padding:1.3em;display:grid;grid-template-columns:30% auto}.container a{color:#fff}.logo{font-size:18px;font-family:Montserrat;background-color:#5b9ce2;width:42%;padding:22px;margin:-21px;margin-right:-33px;padding-right:48px}.confirm-dialog{width:400px;direction:rtl}.confirm-dialog h1{font-size:50px;text-align:center;color:orange;margin:0}.confirm-dialog h2{font-size:18px;text-align:center}.confirm-dialog div{width:100%;display:flex;align-items:center;padding-right:90px}h1{color:#007bff}h2{color:gray;font-size:14px;font-weight:700}section{width:100%;margin:0 auto;font-size:14px}section aside{float:right;width:16%;padding-right:15px;padding-top:15px;background-color:#f8f9fa;min-height:600px;font-family:Montserrat}section aside hr{border-top:1px solid #f5f5f5;margin:3px}section aside div{padding:5px;margin:5px;cursor:pointer}section aside div a{color:grey;text-decoration:none}section aside div a:hover{color:#000;text-underline-position:below}section aside h2{font-size:16px}section main{padding-right:10px;padding-left:10px;border-right:1px solid #dcdcdc;float:right;width:80%;min-height:600px}.btn{font-family:Cairo,sans-serif;border:none;margin:5px;text-transform:uppercase;border-radius:4px;padding:1em;cursor:pointer}.btn-lg{width:100px;font-size:12px}.btn-sm{background-color:#fff;width:40px;font-size:10px;color:gray}.btn-sm:hover{background-color:#dcdcdc}.btn-save{background:#007bff;color:#fff}.btn-cancel{background:red;color:#fff}.results{margin-top:50px}.results strong{display:block}.results span{margin-bottom:20px;display:block}table{margin-top:10px;width:100%;font-family:Cairo,sans-serif!important}table td,table th{border:1px solid #dcdcdc;padding:5px;text-align:center}th.mat-header-cell{text-align:center!important}.mat-elevation-z8{box-shadow:none!important}td.mat-cell:last-of-type,td.mat-footer-cell:last-of-type,th.mat-header-cell:last-of-type{padding-right:0!important}.add-button{margin-top:-45px;float:left;color:green;cursor:pointer;margin-left:20px}.selected{color:#007bff;font-weight:700}.selected:hover{color:#007bff}.mat-paginator-range-label{margin:0 32px 0 24px}.mat-paginator-container{display:flex;align-items:center;justify-content:flex-end;min-height:56px;padding:0 8px;flex-wrap:wrap-reverse;width:100%;direction:ltr}.mat-simple-snackbar{display:flex;justify-content:space-between;align-items:center;height:100%;line-height:20px;opacity:1;float:right}.mat-simple-snackbar{font-family:Cairo,sans-serif;font-size:14px;color:#f8f9fa}input[type=date],input[type=datetime-local],input[type=time]{text-align:right}td.mat-cell:first-of-type,td.mat-footer-cell:first-of-type,th.mat-header-cell:first-of-type{padding-left:24px;padding-right:20px}.visit-label{background-color:#d3d3d3;width:98%;color:bold;font-size:18px;margin-bottom:2px}label{float:right;padding:10px;width:300px}label input{width:200px}label select{width:230px}br,hr{clear:both}table{border-spacing:0}fieldset{border:solid 1px #d3d3d3;margin-bottom:20px}.order-hour{margin-top:10px;margin-right:500px;background-color:gray;padding:15px;color:#fff;font-size:20px}input[disabled]{background-color:#fff}";

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() isHoursReadGreaterThan10000: boolean = false;

  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  powerTrains: any;
  resource: Engine = new Engine();
  maintenance: any = { from: null, to: null };
  engineVisits: any[];

  constructor(
    private spinner: SpinnerService,
    private service: EngineService,
    private visitService: VisitService,
    private msg: MessageService
  ) {}

  ngOnInit() {
    if (!this.isHoursReadGreaterThan10000) this.search();
  }

  search() {
    ELEMENT_DATA = [];
    this.getResources(this.maintenance.from, this.maintenance.to);
  }

  getResources(min: any, max: any) {
    // if (!min || min == "null") min = 0;
    // if (!max || max == "null") max = 100000;
    // min = parseInt(min);
    // max = parseInt(max);
    ELEMENT_DATA = [];
    this.service
      .getEnginesWithLastOrderAndLastVisitByFromandToMaintenanceValues(min, max)
      .subscribe((result: any) => {
        ELEMENT_DATA = ELEMENT_DATA.concat(result);
        this.updateDataSource();
        // for (let eng of result) {
        //   this.spinner.show();
        //   forkJoin(
        //     [
        //       this.visitService.getEngineLastVisitHour(eng.id),
        //       this.visitService.getEngineLastOrderDetails(eng.id),
        //     ])
        //     .subscribe((results: any) => {
        //       this.spinner.hide();
        //       this.engineVisits = results[0];
        //       let lastEngineVisit = results[0][0];
        //       let lastEngineOrder = results[1][0];

        //       eng.lastHourRead = lastEngineVisit ? lastEngineVisit.hoursread : eng.hoursread;
        //       eng.lastMaintenance = lastEngineOrder ? lastEngineOrder.orderHour : 0;

        //       if (eng.lastHourRead >= min && eng.lastHourRead <= max) {
        //         let list = [];
        //         list.push(eng);
        //         ELEMENT_DATA = ELEMENT_DATA.concat(list);
        //         this.updateDataSource();
        //       }

        //       return;

        //       // if (this.isHoursReadGreaterThan10000) {
        //       //   let is10000Engines = [];
        //       //   let checkIfExist = false;
        //       //   let resIs10000 = false;
        //       //   for (let r of results[0]) {
        //       //     if (r.hoursread >= 10000) {
        //       //       resIs10000 = true;
        //       //       for (let en of is10000Engines) {
        //       //         if (en.id == eng.id) {
        //       //           checkIfExist = true;
        //       //         }
        //       //       }
        //       //     }
        //       //   }

        //       //   if (!checkIfExist && resIs10000) {
        //       //     is10000Engines.push(eng);
        //       //     ELEMENT_DATA = ELEMENT_DATA.concat(is10000Engines);
        //       //     this.updateDataSource();
        //       //   }

        //       // } else {
        //       //   let list = [];
        //       //   list.push(eng);
        //       //   ELEMENT_DATA = ELEMENT_DATA.concat(list);
        //       //   this.updateDataSource();
        //       // }

        //     }, (err: any) => {
        //       this.msg.alert(Message.ERROR_IN_GET_LAST_ENGINE_HOURS);
        //     })
        // }
      });
  }

  checkMaxMinHoursRead(min: number, max: number) {
    this.getResources(min, max);
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }
}
